import { computeDepositAmount } from 'checkout/lib/utils/payments/deposit'
import { createSelector } from 'reselect'
import { checkoutAccommodationOfferView } from '../view/accommodation'
import { getAccommodationPayable } from './accommodation'
import getDepositSettings from './deposit/getDepositSettings'

const getAccommodationDepositAmount = createSelector(
  (state: App.State) => getAccommodationPayable(state),
  (state: App.State) => getDepositSettings(state),
  (state: App.State) => checkoutAccommodationOfferView(state),
  (accommodationPayable, depositSettings): number => {
    return computeDepositAmount(accommodationPayable, depositSettings)
  },
)

export default getAccommodationDepositAmount
